var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tk-breadcrumbs',{attrs:{"items":_vm.itemsWithFixedOnes}})
}
var staticRenderFns = []

export { render, staticRenderFns }